const Pagination = Vue.component('pagination', {
	props: {
		currentPage: Number,
		totalPages: Number,
	},
	template: '#pst-pagination',
	methods: {
		navigate(back = false) {
			scroll({
				top: 0,
				behavior: 'smooth',
			});

			back ? this.$emit('previous-page') : this.$emit('next-page');
		},
	},
});

const PolyFilters = Vue.component('poly-filters', {
	props: {
		availableFilters: Array,
	},
	data() {
		return {
			filters: [],
		};
	},
	created() {
		this.filters = this.availableFilters;

		this.filters.forEach((filter) => {
			filter.values.forEach((val) => (val.checked = false));
		});
	},
	template: '#pst-polyfilters',
});

export const PXGlobalSearch = (function () {
	'use strict';

	let app;

	function init() {
		if (!document.getElementById('poly-global-search')) return;

		app = new Vue({
			el: '#poly-global-search',
			components: { PolyFilters, Pagination },
			data() {
				return {
					searchQuery: '',
					results: [],
					totalResults: 0,
					totalPages: 0,
					currentPage: 1,
					filters: {
						postTypes: [],
					},
				};
			},
			mounted() {
				let queryParams = PixelsmithModules.Helpers.getUrlParams(window.location.search);

				if (queryParams.polysearchquery) {
					this.searchQuery = queryParams.polysearchquery;
					this.fetchResults();
				}
			},
			methods: {
				showModal(content) {
					document.getElementById('polywater-modal-content').innerHTML = '<div class="responsive-video">' + content + '</div>';
					MicroModal.show('polywater-modal');
				},
				navigate(back = false) {
					if ((!back && this.currentPage === this.totalPages) || (back && this.currentPage === 1)) return;

					back ? this.currentPage-- : this.currentPage++;

					this.fetchResults();
				},
				filterUpdateHandler(filters) {
					let parsedFilters = JSON.parse(filters);

					this.filters.postTypes = [];

					parsedFilters.forEach((f) => {
						if (f.name === 'Categories') {
							let activePostTypeFilters = f.values.filter((postType) => postType.checked);

							activePostTypeFilters.forEach((p) => this.filters.postTypes.push(p.slug));
						}
					});

					this.fetchResults();
				},
				fetchResults($event) {
					if ($event) $event.preventDefault();

					let searchEndpoint = `/wp-json/wp/v2/polysearch?s=${this.searchQuery}`;
					let newUrl = `?polysearchquery=${this.searchQuery}`;
					let queryParams = PixelsmithModules.Helpers.getUrlParams(window.location.search);

					if (queryParams.postTypes) {
						newUrl += `&postTypes=${queryParams.postTypes}`;
					}

					if (this.filters.postTypes.length > 0) {
						searchEndpoint += `&postTypes=${this.filters.postTypes.join(',')}`;
						newUrl += `&postTypes=${this.filters.postTypes.join(',')}`;
					}

					searchEndpoint += `&page=${this.currentPage}`;
					searchEndpoint += `&currentLang=${PXConstants.current_site_language}`;

					if (PXIsAdmin['admin'] !== 'true') {
						history.pushState(
							{ polysearchquery: this.searchQuery, postTypes: this.filters.postTypes, hash: window.location.hash },
							'A new search query: ${this.searchQuery}',
							newUrl
						);
					}

					axios
						.get(searchEndpoint)
						.then((response) => {
							console.log(searchEndpoint)
							this.totalResults = +response.headers['x-wp-total'];
							this.totalPages = +response.headers['x-wp-totalpages'];
							this.results = response.data;
						})
						.catch((error) => console.log(error));
				},
				// make sure to reset search query & filters
				clearAll() {
					this.searchQuery = '';

					let checkedItems = [];
					$.each($('.pst-filters').find('label'), function (i, val) {
						const self = $(val);

						if (self.find('input').is(':checked')) {
							checkedItems.push(self);
						}
					});

					$.map(checkedItems, function (element, index) {
						return $(element).click();
					});
				},
			},
		});
	}

	return {
		init: init,
	};
})();
